import type { Meta } from '../../../generated/frontend'
import { getUpdatedAtDate } from '../../../shared/utils/get-updated-at-date'
import { removeUrlQueryStringAndFragment } from '../../../shared/utils/remove-url-query-string-and-fragment'
import { getPageComponentsText } from './get-components-text'

export const baseDataLayer = (
  meta: Meta,
  urls: { currentUrl: string; previousUrl?: string },
  articleBodyTemplate: Record<string, any>
) => ({
  wcdPageUrl: removeUrlQueryStringAndFragment(urls.currentUrl),
  previousWcdPageUrl: urls.previousUrl || '',
  pageComponents: getPageComponentsText(articleBodyTemplate),
  contentPublishedDate: getUpdatedAtDate(meta.publishedDate),
  contentUpdatedDate: getUpdatedAtDate(meta.updatedDateTime),
  systemContentPublishedDate: getUpdatedAtDate(meta.systemContentPublishedDate),
  systemContentUpdatedDate: getUpdatedAtDate(meta.systemContentUpdatedDate),
  glideCurationDate: meta.glideCurationDate,
  frequencyOfUpdate: meta.frequencyOfUpdate,
  significantUpdate: meta.significantUpdate,
})
